export default [
  {
    path:"/birth-consultation",
    name:"Birth-consultation",
    component: () => import("@/components/adm/birth-consultation/BirthConsultation.vue"),
    meta: {
      title: "Controle leiteiro > Controle de Parto > Consulta de Parto"
    }
  },
]